import React from 'react';
import { Box, Rating, Typography } from '@mui/material';
import { Star as StarIcon } from '@mui/icons-material';
import brand from '../../../config/brand';

interface StarRatingProps {
  value: number;
  onChange?: (value: number | null) => void;
  readOnly?: boolean;
  size?: 'small' | 'medium' | 'large';
  showValue?: boolean;
  precision?: number;
}

const StarRating: React.FC<StarRatingProps> = ({
  value,
  onChange,
  readOnly = false,
  size = 'medium',
  showValue = true,
  precision = 0.5,
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Rating
        value={value}
        onChange={(_event, newValue) => onChange?.(newValue)}
        readOnly={readOnly}
        precision={precision}
        size={size}
        emptyIcon={
          <StarIcon
            style={{ opacity: 0.3 }}
            fontSize="inherit"
          />
        }
        sx={{
          '& .MuiRating-iconFilled': {
            color: brand.colors.fire,
          },
          '& .MuiRating-iconHover': {
            color: brand.colors.fireSecondary,
          },
          '& .MuiRating-iconEmpty': {
            color: `rgba(${brand.colorsRgb.fire}, 0.3)`,
          },
          transition: 'transform 0.2s ease',
          ...(!readOnly && {
            '&:hover': {
              transform: 'scale(1.05)',
            },
          }),
        }}
      />
      {showValue && (
        <Typography
          variant={size === 'large' ? 'h6' : size === 'medium' ? 'body1' : 'body2'}
          fontWeight={600}
          color="text.primary"
        >
          {value > 0 ? value.toFixed(1) : '--'}
        </Typography>
      )}
    </Box>
  );
};

export default StarRating;
